module.exports = __webpack_public_path__ + "img/cover-favorite-bg-mobile.9b36f8ad.jpg";